import React from 'react';

const BuyMeCoffee: React.FC = () => {
  return (
    <a
      href="https://buymeacoffee.com/glorentz.dev"
      target="_blank"
      rel="noopener noreferrer"
      className="buy-me-coffee"
      aria-label="Buy me a coffee"
      title="Support this project"
    >
      ☕
    </a>
  );
};

export default BuyMeCoffee;
